"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var ChevronRight = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '8' : _b, _c = _a.height, height = _c === void 0 ? '12' : _c, _d = _a.fillColor, fillColor = _d === void 0 ? '#2D2926' : _d, rest = __rest(_a, ["width", "height", "fillColor"]);
    return (react_1["default"].createElement("svg", __assign({ width: width, height: height, viewBox: "0 0 8 12" }, rest),
        react_1["default"].createElement("path", { d: "M1.29594 11.3336C1.16631 11.3334 1.04117 11.286 0.943944 11.2003C0.852565 11.1212 0.800049 11.0064 0.800049 10.8856C0.800049 10.7648 0.852565 10.6499 0.943944 10.5709L6.00528 6.00025L0.943944 1.42959C0.852565 1.35057 0.800049 1.23573 0.800049 1.11492C0.800049 0.994113 0.852565 0.879273 0.943944 0.800253C1.14442 0.626478 1.44214 0.626478 1.64261 0.800253L7.05595 5.68559C7.1457 5.76583 7.19789 5.87988 7.19995 6.00025C7.19855 6.12077 7.14624 6.23508 7.05595 6.31492L1.64261 11.2003C1.54676 11.2848 1.42374 11.3321 1.29594 11.3336Z", fill: fillColor })));
};
exports["default"] = ChevronRight;
